<template>
  <div class="locations-page">
    <div class="container">
      <h1>Locations</h1>
      <div class="center" v-if="userIsAdmin">
        <b-button @click="displayForm()" v-if="showAddButton">
          Add Location
        </b-button>
        <div v-else>
          <h5>Location Name</h5>
          <b-form-input
            v-model="form.name"
            type="text"
            placeholder="Location Name"
            required
            @keydown.native.enter="onSubmit()"
          ></b-form-input>
          <h5>Address (optional)</h5>
          <b-form-input
            v-model="form.address.line1"
            type="text"
            @keydown.native.enter="onSubmit()"
          ></b-form-input>
          <b-form-input
            v-model="form.address.line2"
            type="text"
            @keydown.native.enter="onSubmit()"
          ></b-form-input>
          <b-form-input
            v-model="form.address.line3"
            type="text"
            @keydown.native.enter="onSubmit()"
          ></b-form-input>
          <b-form-input
            v-model="form.address.line4"
            type="text"
            @keydown.native.enter="onSubmit()"
          ></b-form-input>
          <b-form-input
            v-model="form.address.line5"
            type="text"
            @keydown.native.enter="onSubmit()"
          ></b-form-input>
          <b-button
            v-if="isSavingNewAddition == false"
            @click="onSubmit()"
            variant="primary"
          >
            Submit
          </b-button>
          <b-button v-else variant="primary">
            <b-spinner small variant="white" label="Saving..."></b-spinner>
          </b-button>
          <b-button @click="onCancel()">Cancel</b-button>
        </div>
      </div>
      <br />
      <div class="locations-table mt-4">
        <b-table
          :fields="fields"
          :items="items"
          tbody-tr-class="locations-table-row"
          small
          sort-by="name"
          sort-icon-left
        >
          <template #cell(name)="row">
            <span v-if="!row.item.makeEdit">{{ row.item.name }}</span>
            <span v-else class="input-group">
              <b-form-input
                size="sm"
                v-model="row.item.edittedName"
                @keydown.native.enter="saveEdit(row)"
              />
              <span class="input-group-btn">
                <b-button
                  v-if="row.item.isSavingEdit == false"
                  variant="primary"
                  @click="saveEdit(row)"
                >
                  Save
                </b-button>
                <b-button v-else variant="primary">
                  <b-spinner
                    small
                    variant="white"
                    label="Text Centered"
                  ></b-spinner>
                </b-button>
              </span>
            </span>
          </template>
          <template #cell(address)="row">
            <template v-if="!row.item.makeEdit">
              {{ row.value.line1 }}<br v-if="row.value.line1" />
              {{ row.value.line2 }}<br v-if="row.value.line2" />
              {{ row.value.line3 }}<br v-if="row.value.line3" />
              {{ row.value.line4 }}<br v-if="row.value.line4" />
              {{ row.value.line5 }}<br v-if="row.value.line5" />
            </template>
            <template v-else>
              <b-form-input
                v-model="row.item.edittedAddress.line1"
                type="text"
                class="mb-1"
                @keydown.native.enter="onSubmit()"
              ></b-form-input>
              <b-form-input
                v-model="row.item.edittedAddress.line2"
                type="text"
                class="mb-1"
                @keydown.native.enter="onSubmit()"
              ></b-form-input>
              <b-form-input
                v-model="row.item.edittedAddress.line3"
                type="text"
                class="mb-1"
                @keydown.native.enter="onSubmit()"
              ></b-form-input>
              <b-form-input
                v-model="row.item.edittedAddress.line4"
                type="text"
                class="mb-1"
                @keydown.native.enter="onSubmit()"
              ></b-form-input>
              <b-form-input
                v-model="row.item.edittedAddress.line5"
                type="text"
                class="mb-1"
                @keydown.native.enter="onSubmit()"
              ></b-form-input>
            </template>
          </template>
          <template #cell(edit_and_delete_location)="row">
            <span class="input-group" v-if="userIsAdmin">
              <b-button
                variant="link"
                v-if="row.item.makeEdit == false"
                @click="editLocation(row)"
              >
                <b-icon variant="secondary" icon="pencil-fill" />
              </b-button>
              <b-button variant="link" v-else @click="cancelEdit(row)">
                <b-icon variant="secondary" icon="x-circle" />
              </b-button>
              <b-button variant="link" @click="showDeleteModal(row)">
                <b-icon
                  variant="secondary"
                  icon="trash-fill"
                  aria-hidden="true"
                />
              </b-button>
            </span>
          </template>
          <template #table-colgroup="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :class="`locations-table-${field.key}`"
            />
          </template>
        </b-table>
      </div>
    </div>
    <b-modal
      id="confirm-delete-modal"
      title="Confirm Deletion"
      @ok="deleteLocation(selectedLocation)"
      header-bg-variant="danger"
      header-text-variant="white"
      ok-variant="danger"
      ok-title="Delete"
    >
      <p class="my-4">
        Are you sure you want to delete the
        {{ selectedLocation.name }} location?
      </p>
    </b-modal>
    <b-modal
      id="error-modal"
      header-bg-variant="danger"
      ok-variant="danger"
      ok-title="Dismiss"
      header-text-variant="white"
      ok-only
    >
      <template #modal-header>
        <h4>
          <b-icon icon="exclamation-triangle-fill" /> Error: {{ errorMessage }}
        </h4>
      </template>
      <p v-if="errorDetails !== []">
        Encountered {{ errorDetails.length }} error{{
          errorDetails.length > 1 ? "s" : ""
        }}:
      </p>
      <b-list-group v-if="errorDetails !== []">
        <b-list-group-item v-for="detail in errorDetails" :key="detail">
          {{ detail }}
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
var axios = require("axios").default;
export default {
  props: ["userIsAdmin"],
  data: function() {
    return {
      locations: [],
      fields: [
        { key: "name", sortable: true },
        { key: "address", sortable: true },
        { key: "edit_and_delete_location", label: "" },
      ],
      items: [],
      form: {
        name: "",
        address: {
          line1: "",
          line2: "",
          line3: "",
          line4: "",
          line5: "",
        },
      },
      showAddButton: true,
      isSavingNewAddition: false,
      selectedLocation: {},
      errorMessage: "A server error occurred",
      errorDetails: [],
    };
  },
  methods: {
    async getLocations() {
      this.locations = await axios.get("/api/v1/locations");
    },
    displayForm() {
      this.showAddButton = false;
      this.isSavingNewAddition = false;
    },
    editLocation(row) {
      row.item.makeEdit = true;
      row.item.edittedName = row.item.name;
      row.item.edittedAddress = { ...row.item.address };
    },
    showDeleteModal(row) {
      this.selectedLocation = row.item;
      this.$bvModal.show("confirm-delete-modal");
    },
    deleteLocation(location) {
      this.errorDetails = [];
      axios
        .delete("/api/v1/locations/" + String(location.id))
        .then(() => {
          //Remove deleted object from b-table items
          this.items = this.items.filter((item) => item.id !== location.id);
        })
        .catch((errors) => {
          if (!errors.response) {
            this.errorMessage = "Failed to reach server.";
            this.$bvModal.show("error-modal");
          } else {
            this.errorDetails = this.formatDetails(
              errors.response.data.error.base
            );
            this.errorMessage = `Failed to delete ${location.name}.`;
            this.$bvModal.show("error-modal");
          }
        });
    },
    cancelEdit(row) {
      row.item.makeEdit = false;
      row.item.edittedName = row.item.name;
    },
    saveEdit(row) {
      this.errorDetails = [];
      row.item.isSavingEdit = true;
      axios
        .put("/api/v1/locations/" + String(row.item.id), {
          name: row.item.edittedName,
          address: row.item.edittedAddress,
        })
        .then(() => {
          row.item.isSavingEdit = false;
          row.item.makeEdit = false;
          row.item.name = row.item.edittedName; // So current table updates without page refresh
          row.item.address = row.item.edittedAddress; // So current table updates without page refresh
        })
        .catch((errors) => {
          row.item.isSavingEdit = false;
          if (!errors.response) {
            this.errorMessage = "Failed to reach server.";
            this.$bvModal.show("error-modal");
          } else {
            this.errorDetails = this.formatDetails(errors.response.data.error);
            this.errorMessage = "Failed to save location.";
            this.$bvModal.show("error-modal");
          }
        });
    },
    onSubmit() {
      this.errorDetails = [];
      this.isSavingNewAddition = true;
      axios
        .post("/api/v1/locations", {
          name: this.form.name,
          address: this.form.address,
        })
        .then((response) => {
          this.items.push(
            this.createNewItem(
              response.data._id.$oid,
              response.data.name,
              response.data.address
            )
          );
          this.showAddButton = true;
          this.form.name = "";
          this.form.address = {
            line1: "",
            line2: "",
            line3: "",
            line4: "",
            line5: "",
          };
          this.isSavingNewAddition = false;
        })
        .catch((errors) => {
          this.isSavingNewAddition = false;
          if (!errors.response) {
            this.errorMessage = "Failed to reach server.";
            this.$bvModal.show("error-modal");
          } else {
            this.errorDetails = this.formatDetails(errors.response.data.error);
            this.errorMessage = "Failed to save location.";
            this.$bvModal.show("error-modal");
          }
        });
    },
    formatDetails(details) {
      if (Array.isArray(details)) {
        return details;
      } else if (typeof details === typeof {}) {
        var detailsArray = [];
        Object.entries(details).forEach((entry) => {
          const [key, value] = entry;
          if (Array.isArray(value)) {
            value.forEach((message) => {
              detailsArray.push(`${key} ${message}`);
            });
          } else {
            detailsArray.push(`${key} ${value}`);
          }
        });
        return detailsArray;
      } else {
        return [details];
      }
    },
    onCancel() {
      this.showAddButton = true;
      this.form.name = "";
    },
    createNewItem(id, name, address) {
      return {
        id: id,
        name: name,
        address: address,
        makeEdit: false,
        edittedName: name,
        isSavingEdit: false,
      };
    },
    getCSRFToken() {
      return document.querySelector("[name=csrf-token]").content;
    },
    setRequestHeaders() {
      axios.defaults.headers.common["X-CSRF-TOKEN"] = this.getCSRFToken();
    },
  },
  created: function() {
    this.setRequestHeaders();
    this.getLocations()
      .then(() => {
        for (var i = 0; i < this.locations.data.length; i++) {
          this.items.push(
            this.createNewItem(
              this.locations.data[i]._id.$oid,
              this.locations.data[i].name,
              this.locations.data[i].address
            )
          );
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  },
};
</script>

<style>
.locations-table {
  margin-left: auto;
  margin-right: auto;
  width: 40rem;
}
.locations-table-row > td {
  vertical-align: middle !important;
}
.locations-table-edit_and_delete_location {
  width: 7rem;
}
</style>
